import React from 'react';
import styled from '@emotion/styled';

const Container = styled.main`
  max-width: 800px;
  margin: 2rem auto;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  color: #333;
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 1.5rem;
  color: var(--primary);
`;

const Section = styled.section`
  margin-bottom: 2rem;
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: var(--secondary);
`;

const Text = styled.p`
  margin-bottom: 1rem;
  line-height: 1.6;
`;

const List = styled.ul`
  margin-left: 2rem;
  margin-bottom: 1rem;
`;

const ListItem = styled.li`
  margin-bottom: 0.5rem;
  line-height: 1.6;
`;

const Terms: React.FC = () => {
  return (
    <Container>
      <Title>Terms of Service</Title>
      
      <Section>
        <SectionTitle>1. Acceptance of Terms</SectionTitle>
        <Text>
          By accessing and using Pop Fidget Toy (pop-fidget-toy.com), you accept and agree 
          to be bound by these Terms of Service.
        </Text>
      </Section>

      <Section>
        <SectionTitle>2. Use of Service</SectionTitle>
        <Text>Our service is provided for entertainment and stress relief purposes.</Text>
        <List>
          <ListItem>You must use the service in accordance with all applicable laws</ListItem>
          <ListItem>You may not interfere with or disrupt the service</ListItem>
          <ListItem>You may not attempt to gain unauthorized access to the service</ListItem>
        </List>
      </Section>

      <Section>
        <SectionTitle>3. Intellectual Property</SectionTitle>
        <Text>
          All content, features, and functionality of Pop Fidget Toy are owned by us and 
          are protected by international copyright, trademark, and other intellectual 
          property laws.
        </Text>
      </Section>

      <Section>
        <SectionTitle>4. Advertising</SectionTitle>
        <Text>
          Our website displays advertisements provided by Google AdSense and other advertising 
          partners. By using our service, you agree to:
        </Text>
        <List>
          <ListItem>The display of advertisements on the website</ListItem>
          <ListItem>The collection and use of data for personalized advertising</ListItem>
          <ListItem>The use of cookies for advertising purposes</ListItem>
          <ListItem>Not using ad blockers or interfering with ad delivery</ListItem>
          <ListItem>Not clicking on ads in a fraudulent manner or encouraging others to do so</ListItem>
        </List>
        <Text>
          We reserve the right to modify ad placements and partnerships at any time without notice.
        </Text>
      </Section>

      <Section>
        <SectionTitle>5. Disclaimer</SectionTitle>
        <Text>
          Pop Fidget Toy is provided "as is" without any warranties, expressed or implied. 
          We do not guarantee that the service will be uninterrupted or error-free.
        </Text>
      </Section>

      <Section>
        <SectionTitle>6. Limitation of Liability</SectionTitle>
        <Text>
          We shall not be liable for any indirect, incidental, special, consequential, or 
          punitive damages resulting from your use or inability to use the service.
        </Text>
      </Section>

      <Section>
        <SectionTitle>7. Changes to Terms</SectionTitle>
        <Text>
          We reserve the right to modify these terms at any time. Continued use of the 
          service after any changes constitutes acceptance of the new terms.
        </Text>
      </Section>

      <Section>
        <SectionTitle>8. Contact Information</SectionTitle>
        <Text>
          For any questions regarding these Terms of Service, please contact us at:{' '}
          <a href="mailto:exponentialdollar@gmail.com">exponentialdollar@gmail.com</a>
        </Text>
      </Section>

      <Text>Last updated: March 20, 2024</Text>
    </Container>
  );
};

export default Terms; 